
export default {
    name: "Info",
    props: {
        text: String,
    },
    data() {
        return {
            showInfo: false,
        };
    },

    mounted() {
        document.addEventListener('click', () => {
            if (!this.$el.contains(event.target)) {
                this.showInfo = false;
            }
        });
    },

    methods: {
        onMouseOver() {
            this.showInfo = true;
        },
        onMouseLeave() {
            this.showInfo = false
        },
        onClickGotIt() {
            this.showInfo = false;
        },


    },
    destroyed: function () {
        // Clean up the click event listener
        document.removeEventListener('click', () => {
            if (!this.$el.contains(event.target)) {
                this.showInfo = false;
            }
        });
    },
};
